import React, { useRef, useState, useEffect } from "react";
//import { GoogleMap, InfoWindow, Marker, Polyline } from "@react-google-maps/api";
import { useLoadScript } from "@react-google-maps/api";
import { MarkerF } from "@react-google-maps/api";
import { MapContainer, TileLayer, Marker, Popup, Polyline } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

function MapView({ routeOptions }) {

  // const mapRef = useRef(null);
  // const libraries = ["places"];
  const [selectedMarker, setSelectedMarker] = useState(null);
  // const [infoWindowData, setInfoWindowData] = useState(null);
  const [polylinePath, setPolylinePath] = useState([]);


  useEffect(() => {
    if (routeOptions && Array.isArray(routeOptions)) {
      const newPath = routeOptions.map(option => ({
        lat: parseFloat(option.collectionPointLatitude),
        lng: parseFloat(option.collectionPointLogitude)
      }));
      setPolylinePath(newPath);
    }
  }, [routeOptions]);

  // const { isLoaded, loadError } = useLoadScript({
  //   googleMapsApiKey: "AIzaSyCGyRUOXr1o2YafH7C2w5UN5wy8ghCrWhg", // Replace with your Google Maps API key
  //   libraries,
  // });
  // Check if the routeOptions is valid
  if (!routeOptions || !Array.isArray(routeOptions)) {
    return null;
  }
 // if (loadError) return "Error loading maps";
 // if (!isLoaded) return "Loading maps...";
  // Custom marker icon
  const customMarkerIcon1 = {
    url: "../../../assets/images/locationgreen.svg",
    scaledSize: new window.google.maps.Size(50, 50), // Adjust the size as needed
  };

  const Mylocation = {
    url: "../../../assets/images/gpsicon.png",
    scaledSize: new window.google.maps.Size(50, 50),
  };

  const handleMarkerClick = (result) => {
    setSelectedMarker(result);
    // setInfoWindowData(j);
  };

  const handleMarkerClose = () => {
    setSelectedMarker(null);
    //setInfoWindowData(false);
  };

  const customMarkerIcon = (status) => {
    switch (status) {
      case "Completed":
        return new L.icon({
          iconUrl: "../../../assets/images/locationgreen.svg",
          iconSize: [50, 50],
        });
      case "Pending":
        return new L.icon({
          iconUrl: "../../../assets/images/locationgray.svg",
          iconSize: [50, 50],

        });
      default:
        return new L.icon({
          iconUrl: "../../../assets/images/locationred.svg",
          iconSize: [50, 50],
        });

    }
  };
  const markerPositions = routeOptions.map(option => ({
    lat: parseFloat(option.collectionPointLatitude),
    lng: parseFloat(option.collectionPointLogitude)
  }));
  const hasMarkers = routeOptions && routeOptions.length && routeOptions.some(option => option.collectionPointLatitude && option.collectionPointLogitude);

  if (!hasMarkers) {
    return <p className="p-4">No points available. Please select date , shift, route.</p>;
  }

  return (
    <>
      <MapContainer
        style={{ width: "100%", height: "550px" }}
        // center={markerPositions.length > 0 ? markerPositions[0] : { lat: 19.5937, lng: 76.9629 }}
        center={polylinePath.length > 0 ? polylinePath[0] : { lat: 17.4065, lng: 78.4772 }}
        zoom={10} // Default zoom level
        // ref={mapRef}
      >
 <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

{markerPositions.map((position, index) => (
          <Marker
            key={index}
            position={position}
            icon={customMarkerIcon(routeOptions[index].status)}
            eventHandlers={{
              click: () => handleMarkerClick(routeOptions[index]),
            }}
          >
            {selectedMarker && selectedMarker.collectionPointLatitude === position.lat && selectedMarker.collectionPointLogitude === position.lng && (
              <Popup
                position={{
                  lat: parseFloat(selectedMarker.collectionPointLatitude),
                  lng: parseFloat(selectedMarker.collectionPointLogitude),
                }}
                onClose={() => setSelectedMarker(null)}
              >
                <div>
                  <h4>Selected Point Details</h4>
                  <h6>
                    Point Name: <b>{selectedMarker.collectionPointName}</b>
                  </h6>
                  <p>
                    Latitude: <b>{selectedMarker.beforeLatitude}</b>
                  </p>
                  <p>
                    Longitude: <b>{selectedMarker.beforeLongitude}</b>
                  </p>
                  <p>
                    Status: <b>{selectedMarker.status}</b>
                  </p>
                  <p>
                    Sort Order: <b>{selectedMarker.sortOrder}</b>
                  </p>
                  <p>
                    Before Pickup Time: {selectedMarker.beforePickupTime}
                  </p>
                  <p>
                    After Pickup Time: {selectedMarker.afterPickupTime}
                  </p>
                </div>
              </Popup>
            )}
          </Marker>
        ))}
         {polylinePath.length > 0 && (
          <Polyline positions={polylinePath} color="red" />
        )}
      </MapContainer>
      {!hasMarkers && <p>No points available. Please select points.</p>}
      {/* <button onClick={handleSearchButtonClick}>Search</button> */}
    </>

  );
}



export default MapView;

